<template>
  
  <div class="flex flex-row h-full justify-around">

      <!-- <div class="w-2/5" v-for="(oneImage, index) in images" :key="index">

           <img :src="oneImage" class="object-cover rounded-full h-64 lg:h-32">
      </div> -->

     <div class="bg-indigo-100" >

          <card-swipe :images="images" ref="cardSwiper" :isTransparent="isTransparent"
            :isFromSessionCard="isFromSessionCard" :isFromPitchCard="isFromPitchCard" :isFromMembershipCard="isFromMembershipCard"/>
     </div>

      <!-- <div class="mt-10 ms-20">

            <my-horizontal-list></my-horizontal-list>
        </div>      -->

  </div>
</template>

<script>

import cardSwipe from '../cards-components/CardSwipe'
import MyHorizontalList from '../../components-v2/controls/MyHorizontalList';

export default {

    mounted(){

        // console.log(`isFromCard: ${this.isFromCard}`)
        // console.log(`images: ${JSON.stringify(this.images)}`);
        // console.log(`images.size: ${JSON.stringify(this.images.length)}`);

    },

    props:{

        images:{

            type: Array
        },
        
        isFromSessionCard: false,
        isFromPitchCard: false,
        isFromMembershipCard: false,

        isTransparent: true,
    },

    methods:{

        swipeLeft(){

            this.$refs.cardSwiper.swipeLeft();
            // console.log(`swipeLeft`);
        },
        
        swipeRight(){

            this.$refs.cardSwiper.swipeRight();
            // console.log(`swipeRight`);
        },  

    },

    components:{

        cardSwipe,
        MyHorizontalList
    }
}
</script>

<style>

</style>